import { Component, Input } from '@angular/core';

import { RoutletNames } from '@common/types/types';

@Component({
    selector: 'aa-routlets',
    templateUrl: './routlets.component.html',
    standalone: false
})
export class RoutletsComponent
{
    @Input() names: RoutletNames = [];
}
